// @ts-nocheck
"use client";
import React, { useEffect, useState } from "react";
import { message } from "antd";
import { Link } from "@/navigation";
import { useCategory } from "@/context/CategoriesContext";
import { useTranslations } from "next-intl";
import { contactInfo, overseasWarehouses } from "@/lib/contacts";
import Follow from "../Social/Follow";
import { subscribeEmail } from "@/lib/api/subscribe";
import Translate2 from "@/components/Translate/index2";
import clsx from "clsx";

const Footer = () => {
	const { categories } = useCategory();

	const t = useTranslations();
	const tContact = useTranslations("contact");

	const [subscribeLoading, setSubscribeLoading] = useState(false);
	const subscribe = async (value: string) => {
		try {
			if (!value) return;
			setSubscribeLoading(true);
			await subscribeEmail({ email: value, subscribe_type: 3 });
			message.success(t("message.subscribeSuccess"));
		} catch (e) {
			message.error(e.message);
		}
		setSubscribeLoading(false);
	};

	const navigation = {
		QUICKLINKS: [
			{ id: 1, name: "menu.home", link: "/", hasSlug: true, show: true },
			{ id: 20, name: "menu.product", link: "/products", hasSlug: true, show: true },
			{ id: 3, name: "menu.blog", link: "/blog", hasSlug: true, show: true },
			{ id: 4, name: "menu.aboutUs", link: "/about-us", hasSlug: true, show: true },
			{ id: 5, name: "menu.contactUs", link: "/contact-us", hasSlug: true, show: true },
		],
		contact: [
			{
				name: `menu.Phone`,
				href: `tel:${contactInfo.phone}`,
				value: `${contactInfo.phone}`,
			},
			{
				name: `common.Email`,
				href: `mailto:${contactInfo.email}`,
				value: `${contactInfo.email}`,
			},
			{
				name: `common.WhatsApp`,
				href: `https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, "")}`,
				value: `${contactInfo.whatsapp}`,
			},
			// {
			// 	name: `common.Address`,
			// 	href: `https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d648.1870392305726!2d113.27367957166912!3d23.217615521951902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDEzJzAyLjQiTiAxMTPCsDE2JzI0LjgiRQ!5e0!3m2!1sen!2shk!4v1745373133813!5m2!1sen!2shk`,
			// 	value: `${contactInfo.address}`,
			// },
		],
	};

	// 平滑滚动到顶部
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};
	useEffect(() => {
		if (window.devicePixelRatio === 1.25) {
			document.body.style.zoom = "0.8";
		}
	}, []);
	return (
		<footer className="footer font-poppins bg-[#272727] text-white">
			{/* logo */}
			<div className="container border-b-[1px] border-[#363636] py-[30px] max-md:py-3">
				<div className="flex flex-col items-center justify-center gap-[16px]">
					<div className="text-[30px] font-bold">
						<p>{t("home.f1")}</p>
					</div>
					<div className="text-[#A3A3A3]">
						<p>{t("home.f2")}</p>
					</div>
					<div>
						<button className="inline-block h-[35px] rounded-md !bg-main px-4">
							<Link href="/products" className="font-bold !text-white hover:!text-black">
								{t("home.Shop Now")}
							</Link>
						</button>
					</div>
				</div>
			</div>

			<div className="container grid grid-cols-1 gap-x-8 gap-y-10 px-4 py-12 max-md:py-6 sm:grid-cols-2 lg:grid-cols-[minmax(0,1.4fr)_minmax(0,0.8fr)_minmax(0,1fr)_minmax(0,1fr)]">
				{/* 订阅 & 社交媒体 */}
				<div className="min-w-0">
					<h3 className="mb-5 text-lg font-bold tracking-wide">{t("home.f3")}</h3>
					<div className="mb-6">
						<SearchInput onSearch={subscribe} className="" />
					</div>
					<div className="flex items-center gap-6">
						<Follow />
					</div>
				</div>

				{/* Quick Links */}
				<div>
					<h3 className="mb-5 text-lg font-bold tracking-wide">{t("menu.Quick Iinks")}</h3>
					<ul className="space-y-3">
						{navigation.QUICKLINKS.map((item) => {
							return (
								item.show && (
									<li key={item.id}>
										<Link
											href={item.link}
											className="text-sm text-[#9a9a9a] transition-colors duration-200 hover:text-white"
										>
											{t(item.name)}
										</Link>
									</li>
								)
							);
						})}
					</ul>
				</div>

				{/* Contact Us */}
				<div>
					<h3 className="mb-5 text-lg font-bold tracking-wide">{t("menu.Contact Us")}</h3>
					<ul className="space-y-3">
						{navigation.contact.map((item) => {
							const isExternal = /^(https?:|mailto:|tel:)/.test(item.href);
							const isHttp = /^https?:/.test(item.href);
							const content = (
								<>
									<span className="text-xs uppercase tracking-widest text-[#666]">{t(item.name)}</span>
									<span className="mt-0.5 text-[#9a9a9a] group-hover:text-white">{item.value}</span>
								</>
							);
							return (
								<li key={item.name}>
									{isExternal ? (
										<a
											href={item.href}
											target={isHttp ? "_blank" : undefined}
											rel={isHttp ? "noopener noreferrer" : undefined}
											className="group flex flex-col text-sm transition-colors duration-200"
										>
											{content}
										</a>
									) : (
										<Link
											href={item.href}
											className="group flex flex-col text-sm transition-colors duration-200"
										>
											{content}
										</Link>
									)}
								</li>
							);
						})}
					</ul>
				</div>

				{/* 支付方式 & 语言 */}
				<div className="flex flex-col justify-between sm:items-end lg:items-end">
					<div>
						<h3 className="mb-5 text-lg font-bold tracking-wide sm:text-right lg:text-right">
							{t("menu.Payment")}
						</h3>
						<div className="grid grid-cols-5 gap-2">
							{Array.from({ length: 10 }).map((_, index) => (
								<img
									src={`/image/paySvg/${index + 1}.svg`}
									key={index}
									className="h-5 w-10 object-contain opacity-70 transition-opacity hover:opacity-100"
									alt=""
								/>
							))}
						</div>
					</div>
					<div className="mt-6 flex items-center gap-4">
						<Translate2 lastScrollPosition={0} />
						<Link
							href="/"
							className="text-xs uppercase tracking-widest text-[#666] transition-colors duration-200 hover:text-white"
						>
							Sitemap
						</Link>
					</div>
				</div>
			</div>

			{/* 海外仓 — 紧凑网格 + 联系页锚点，避免主四栏被地址撑爆 */}
			<div className="border-t border-[#363636]">
				<div className="container px-4 py-10 max-md:py-8">
					<div className="mb-6 flex flex-col gap-2 sm:mb-8 sm:flex-row sm:items-end sm:justify-between sm:gap-4">
						<h3 className="text-lg font-bold tracking-wide text-white">{tContact("warehousesTitle")}</h3>
						<Link
							href="/contact-us#warehouses-heading"
							className="shrink-0 text-sm font-medium text-[#9a6c3b] transition-colors duration-200 hover:text-white"
						>
							{t("footer.warehousesViewAll")}
						</Link>
					</div>
					<ul className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2 lg:grid-cols-4">
						{overseasWarehouses.map((row) => (
							<li key={row.translationKey} className="min-w-0">
								<p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#666]">
									{tContact(row.translationKey)}
								</p>
								<p className="mt-1.5 text-xs leading-snug text-[#9a9a9a]">{row.address}</p>
							</li>
						))}
					</ul>
				</div>
			</div>

			{/* 底部版权 */}
			<div className="container border-t border-[#363636] px-4 py-4">
				<p className="text-center text-sm text-[#8E8E8E]">
					Guangzhou Guangyao Technology Co., Ltd © 2026. All rights reserved.
				</p>
			</div>

			{/* <SliderBar /> */}
		</footer>
	);
};

export default Footer;
function SearchInput({ onSearch, className }: any) {
	const [searchValue, setSearchValue] = useState("");
	const t = useTranslations();
	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter") {
			onSearch(e.currentTarget.value);
		}
	};
	const toSearch = () => {
		// router.push(`/search?q=${value}`);
		onSearch(searchValue);
	};
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchValue(e.target.value);
	};
	return (
		<div className={clsx("relative h-[53px] w-full text-[14px]", className || "")}>
			<div className="flex h-full w-full items-center rounded-[30px] bg-[#2c2c2c] p-[6px]">
				<input
					value={searchValue}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
					className="!text-mainText min-w-0 flex-1 border-none !bg-transparent py-0.5 !pl-3 !shadow-none !outline-none !ring-0 focus:!shadow-none focus:!outline-none focus:!ring-0"
					placeholder={t("footer.emailAddress")}
					autoComplete="off"
				/>
				<button
					onClick={toSearch}
					type="submit"
					className="myhover absolute right-[6px] top-1/2 flex -translate-y-1/2 items-center whitespace-nowrap rounded-3xl bg-[#000000] px-4 py-2 focus:outline-none sm:px-6"
				>
					<span className="pr-2">{t("footer.Subscribe")}</span>
					<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 64 64" fill="#fff">
						<path d="M6.89,64,0,57.11,47.26,9.85H4.92V0H64V59.08H54.15V16.74Z"></path>
					</svg>
				</button>
			</div>
		</div>
	);
}
